var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen display--flex capitalize",class:[
            'screen display--flex capitalize',
            { 'screen__background--green': _vm.callFound },
            { 'screen__background--red': _vm.controler },
            { 'screen__background--blue': !_vm.controler }
        ]},[_c('div',{ref:"container",class:[
            'screen__message capitalize',
            { 'screen__message--loading': _vm.settings.loading },
            { 'screen__message--error': _vm.settings.error }
        ]},[(_vm.callFound)?_c('icon-call-found',{staticClass:"screen__message--call-found position--absolute",class:[
                'screen__message--call-found',
                { 'show': _vm.callFound }
            ]}):_c('div',[_c('icon-no-calls',{staticClass:"screen__message--no-calls position--absolute",class:[
                    'screen__message--no-calls',
                    { 'show': _vm.controler || _vm.settings.error }
                ]}),_c('icon-search-call',{staticClass:"screen__message--searching position--absolute",class:[
                    'screen__message--searching',
                    { 'show': !_vm.controler && !_vm.settings.error }
                ]})],1),_c('span',{staticClass:"screen__message__text"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }